'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ca = {
  code: "ca",
  week: {
    dow: 1,
    doy: 4
  },
  buttonText: {
    prev: "Anterior",
    next: "Seg\xFCent",
    today: "Avui",
    month: "Mes",
    week: "Setmana",
    day: "Dia",
    list: "Agenda"
  },
  weekText: "Set",
  allDayText: "Tot el dia",
  moreLinkText: "m\xE9s",
  noEventsText: "No hi ha esdeveniments per mostrar"
};

exports.default = ca;
